module.exports = __webpack_public_path__ + "img/cam_5_on.b2da6788.png";